import React, { useState, useEffect,useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
//page links  
import sendEmail from '../services/email';
import PhoneCodeList from '../components/PhoneCodeList';
import { IoBusinessOutline } from "react-icons/io5";
import './verify-company-profile.css'; 
import { MdOutlineEmail } from "react-icons/md";
//page links  
export default function Verifycompanyprofile() { 
        const [searchParams] = useSearchParams();
        const [photoURL, setPhotoURL] = useState(""); 
 const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
      const navigate = useNavigate();
        const [guid, setguid] = useState('');
        const [uid, setuid] = useState('');
          const [userlogin, setuserlogin] = useState(false);
  useEffect(() => { 
    const existingUser = Cookies.get("guid");
    if (existingUser) {
      setguid(existingUser);
      setuserlogin(true); 
    } else {     
      navigate('/');
      setuserlogin(false);
    }
  }, []);
  const [Companyinput, setCompanyinput] = useState('');
  const [Websiteinput, setWebsiteinput] = useState('');
  const [Emailinput, setEmailinput] = useState('');
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const Query = query(
          collection(db, "companys"),
          where("guid", "==", guid)
        );
        const snapshot = await getDocs(Query);
        if (!snapshot.empty) {
          // Assuming 'companyname' is a field in the Firestore document
          setCompanyinput(snapshot.docs[0].data().companyname);
          setWebsiteinput(snapshot.docs[0].data().website);
        }
      } catch (error) {
        console.error("Error fetching company:", error);
      }
    };
  
    if (guid) {
      fetchCompany();
    }
  }, [guid]); 
//   const email_verify = async (e) => {
//    e.preventDefault();
//    setLoading(true);
//    if (!Emailinput) {
//     setLoading(false);
//     showToast("Enter Email");
//     return;
// }

// // Trim and convert to lowercase for consistency
// const email = Emailinput.trim().toLowerCase();
// const allowedDomain = "callqr.com";

// // Extract domain from email
// const emailDomain = email.split("@")[1];

// if (emailDomain !== allowedDomain) {
//     setLoading(false);
//     showToast("Only emails from callqr.com are allowed");
//     return;
// }
// sendEmail("support@callqr.com", "Domain Verified", "This is a test email.")
//   .then(console.log)
//   .catch(console.error);
// setLoading(false);
// };
  return (
    <div className="container_roots">
  
  <Helmet>
  <title>EditorTask - India`s Trusted Platform for Jobs & Creative Talent</title>

  <meta name="description" content="Explore freelance opportunities, post job tasks, or showcase your creative work on EditorTask. Connecting job seekers and employers across India."/>
  <meta name="keywords" content="job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work"/>
  <meta name="author" content="editortask.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="EditorTask - India’s Trusted Platform for Jobs & Creative Talent"/>
  <meta property="og:description" content="Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers."/>
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/" />
  <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
  
</Helmet>

      <div className="container_size">
      <div className='post-container'>      
          <div className='post_div'>
            <div className='title-div'>
              <div className='header-text'>Verify Your Company Profile</div>
              <div className='sub-header-text'>Fill in the details to showcase your company on our platform</div>
            </div>
            <table className='data-input-body'>
              <tr><td className='lable-text'>
              Company Name
                </td></tr>
                <tr><td >
             <b className='bold-data-input'>{Companyinput}</b>
                </td></tr>
                <tr><td className='lable-text'>
              Company Website
                </td></tr>
                <tr><td className='data-text'>
                <b>{Websiteinput}</b>
                </td></tr>
                <tr><td className='lable-text'>
                Email – Domain Verification
                </td></tr>
                <tr><td >
                
             <input className='info-data-input' maxLength={60}
                     onChange={(e) => setEmailinput(e.target.value)}
             placeholder='Your Email'></input>
            
                </td></tr>
                </table>
                <br/>
           <div className='button-ui' ><MdOutlineEmail className='icon' />
           {loading ? <Lodinging /> : "Verify"}
           </div>
            </div>


            {/* post_updates */}
            {/* <div className='post_updates'>
          <div className='post_div' >
            
            post_div</div>
          </div>   */}
            </div>
      </div>
</div>
    );
}
